import { Dispatch } from "@reduxjs/toolkit";
import { ModalId } from "../../../enums/modalId";
import { setOpenedModalId } from "../../../redux/slice/modalSliceNew";

/**
 * Handler for Send to SFTP button click
 * Opens the PUSH_TO_SFTP_MODAL by dispatching to Redux store
 * Mode: 'push' - checkboxes will be disabled for already successful items
 * @param showDownloadColumn - optional flag to show download column in the modal table
 */
export const handleSendToSftpClick = (
  dispatch: Dispatch,
  showDownloadColumn?: boolean,
) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.PUSH_TO_SFTP_MODAL,
      metaData: {
        mode: "push",
        timestamp: new Date().toISOString(),
        showDownloadColumn: showDownloadColumn ?? false,
      },
    }),
  );
};

export const handlePushedDownloadClick = (
  dispatch: Dispatch,
  showDownloadColumn?: boolean,
) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.PUSH_TO_SFTP_MODAL,
      metaData: {
        mode: "pushedDownload",
        timestamp: new Date().toISOString(),
        showDownloadColumn: showDownloadColumn ?? false,
      },
    }),
  );
};

/**
 * Handler for Track Status button click
 * Opens the Track Status tabbed modal (SFTP Files + Track Status date range tabs)
 */
export const handleTrackStatusClick = (dispatch: Dispatch) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.ASTERA_TRACK_STATUS_MODAL,
    }),
  );
};

export const handleTextNoteButtonClick = (dispatch: Dispatch) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.PUSH_TO_SFTP_MODAL,
      metaData: {
        mode: "textNote",
        timestamp: new Date().toISOString(),
      },
    }),
  );
};

/**
 * Handler for SFTP Input Files (download mode) button click
 * Opens the PUSH_TO_SFTP_MODAL with mode 'download' - only shows orders with sftp_status === 'success'
 */
export const handleDownloadFilesClick = (dispatch: Dispatch) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.PUSH_TO_SFTP_MODAL,
      metaData: {
        mode: "download",
        timestamp: new Date().toISOString(),
      },
    }),
  );
};

/**
 * Handler for Download Files button click
 * Opens the Download Files modal with list of files from storage folder
 */
export const handleDownloadFilesModalClick = (dispatch: Dispatch) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.DOWNLOAD_FILES_MODAL,
    }),
  );
};

export const handleUploadTextNotesClick = (dispatch: Dispatch) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.TEXT_NOTE_UPLOAD,
    }),
  );
};
